import { useEffect, useState } from "react";

export default function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      setP(total > 0 ? (h.scrollTop / total) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] pointer-events-none"
      data-testid="scroll-progress"
    >
      <div
        style={{ width: `${p}%` }}
        className="h-full bg-gradient-to-r from-gold-700 via-gold-300 to-gold-700 shadow-[0_0_12px_rgba(212,175,55,0.45)] transition-[width] duration-150"
      />
    </div>
  );
}
